import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from '@mui/material';
import FormInput from 'app/shared-components/formComponents/FormInput';
import { FormProvider, useForm } from 'react-hook-form';
import { IKurvAccountProcessingFormValues, kurvAccountProcessingSchema } from './validation';
import { useStore } from 'zustand';
import { kurvFormSlice } from 'app/store/kurvFormSlice';

interface IProps {
  index: number;
  setNextForm: () => void;
  setPrevForm: () => void;
}

const KurvAccountProcessingForm = ({ setNextForm, setPrevForm }: IProps) => {
  const store = useStore(kurvFormSlice);

  const methods = useForm<IKurvAccountProcessingFormValues>({
    mode: 'onChange',
    values: store.accountProcessing,
    resolver: yupResolver(kurvAccountProcessingSchema),
  });
  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = methods;

  return (
    <FormProvider {...methods}>
      <form
        className="flex flex-col flex-1 justify-between mt-16"
        onSubmit={handleSubmit((d) => {
          store.setAccountProcessing(d);
          setNextForm();
        })}
      >
        <div>
          <FormInput
            className="mt-20 "
            id="ein"
            label="EIN*"
            errorMessage={errors.ein?.message}
            control={control}
            variant="outlined"
            fullWidth
          />
          <FormInput
            className="mt-20"
            id="ssn"
            label="SSN*"
            errorMessage={errors.ssn?.message}
            control={control}
            variant="outlined"
            fullWidth
          />

          <FormInput
            className="mt-20"
            id="idNum"
            label="License #*"
            errorMessage={errors.idNum?.message}
            control={control}
            variant="outlined"
            fullWidth
          />
          <FormInput
            className="mt-20"
            id="dda"
            label="DDA - Direct Deposit Account*"
            errorMessage={errors.dda?.message}
            control={control}
            variant="outlined"
            fullWidth
          />
          <FormInput
            className="mt-20"
            id="sales_vol"
            label="Maximum Monthly Sales Volume*"
            errorMessage={errors.sales_vol?.message}
            control={control}
            variant="outlined"
            fullWidth
          />
        </div>

        <div className="flex justify-end gap-[10px]">
          <Button
            variant="text"
            color="secondary"
            className="mt-16 text-[#111827] disabled:text-dark-primary disabled:text-opacity-60"
            aria-label="Back"
            type="button"
            onClick={setPrevForm}
            size="large"
          >
            Back
          </Button>
          <Button
            variant="contained"
            color="secondary"
            className="mt-16 text-white bg-blue-primary disabled:text-dark-primary disabled:bg-gray-400 disabled:text-opacity-60"
            aria-label="Next step"
            type="submit"
            size="large"
            disabled={!isValid}
          >
            Next step
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};

export default KurvAccountProcessingForm;
